import { useTheme } from "styled-components";

import {
  StyledTableDaysRow,
  StyledTableDaysCell,
} from "./table-days-row.style";

export const TableDaysRow = () => {
  const dayNamesOfWeekArray = [
    "Панядзелак",
    "Аўторак",
    "Серада",
    "Чацвер",
    "Пятніца",
    "Субота",
    "Нядзеля",
  ];

  const theme = useTheme();

  return (
    <StyledTableDaysRow>
      {dayNamesOfWeekArray.map((item, index) => (
        <StyledTableDaysCell
          key={index}
          style={index === 6 ? { color: theme.calendar.fontColors.sunday } : {}}
        >
          {item}
        </StyledTableDaysCell>
      ))}
    </StyledTableDaysRow>
  );
};
